import { useCities } from '~/store/cites/cities.store'
import { useMainStore } from '~/store/main/main.store'

export function getAddressLocation(returnOnly?: boolean) {
  const ctx = useNuxtApp()
  const client = ctx._apolloClients.default
  const cityStore = useCities()
  const mainStore = useMainStore()
  const currentCity = computed(() => cityStore.getCity)

  const getAddressLoc = async (input: Record<string, any>) => {
    try {
      const res = await client.query({
        query: gql`
          query getLocation($input: LocationInfoInput!) {
            location {
              reducedLocation(input: $input) {
                fiasRegion
                hash
                autoGeneratedUrl
                addrObjFiasId
                houseFiasId
                streetFiasId
                fiasPath
                houseId
                addressName
                houseNumber
                houseType
                lat
                lon
                houseUrl
                flat
                floor
                entrance
              }
            }
          }
        `,
        variables: {
          input: {
            addrObjFiasId: currentCity.value?.fias_id,
            ...input,
          },
        },
      })

      const locationData = res?.data?.location?.reducedLocation
      if (!locationData) return null

      if (!returnOnly && locationData.hash) {
        const houseCheck = Boolean(
          locationData.houseId
          || locationData.houseFiasId
          || (locationData.streetFiasId && locationData.houseNumber),
        )

        cityStore.house = locationData.autoGeneratedUrl && houseCheck ? locationData : {}
      }

      return locationData
    }
    catch (error) {
      console.error('Error fetching address location:', error)
      return null
    }
  }

  return { getAddressLoc }
}
